module.exports = __webpack_public_path__ + "img/11.23555ef5.svg";